import axios from 'axios'

const authentication = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_FUNCTIONS}`
});

export default authentication